
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingAncillaries } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormAncillaries = () => {

    const { t } = useTranslation('booking');

    const ancillariesQuery = useQuery({
        queryKey: [ReactQueryKey.BookingAncillaries],
        queryFn: getBookingAncillaries,
        enabled: false
    });

    const handleOnOpen = () => {
        if(ancillariesQuery.data?.ancillaries == undefined) 
            ancillariesQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="ancillaries"
            label={t('label.ancillaries')}
            options={ancillariesQuery.data?.ancillaries ?? []}
            loading={ancillariesQuery.isLoading}
            isOptionEqualToValue={(option, value) => option?.ancillaryCode === value?.ancillaryCode}
            getOptionLabel={(option) => (option.ancillaryCode + ' - ' + option.label)}
            multiple
            onOpen={handleOnOpen}
        />
    );
};

export default FormAncillaries;
